/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = document.querySelectorAll('.accordion-item');
  
  accordionItems.forEach((item, index) => {
    const title = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');

    if (index === 0) {
      // Keep the first item open
      item.classList.add('active');
      content.style.display = 'block';
    } else {
      // Close other items
      content.style.display = 'none';
    }

    title.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      document.querySelectorAll('.accordion-item').forEach((otherItem, otherIndex) => {
        const otherContent = otherItem.querySelector('.accordion-content');

        if (otherItem === item) {
          otherItem.classList.toggle('active');
          otherContent.style.display = isActive ? 'none' : 'block';
        } else {
          otherItem.classList.remove('active');
          otherContent.style.display = 'none';
        }
      });
    });
  });
});


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
